<ng-template #leftPanel>
    <div
        class="contentGrid input-grid-gaps w-full"
        [class.contentGrid-splitter]="useSplitter()"
    >
        <app-work-detail-select-service
            (selectedService)="form.patchValue({ serviceId: $event })"
            [preselected]="form.getRawValue().serviceId || this.store.globalGlobalStore.loggedUserStore.selectedServiceId()"
            [workType]="WorkTypeEnum.GROUP_ACTIVITY"
            [allowedTypes]="[ServiceTypeEnum.SOCIAL]"
            [disabled]="form.controls.serviceId.disabled"
        ></app-work-detail-select-service>

        <app-input-user-multiselect
            #selectUserComponent
            [form]="form"
            [label]="prefix + 'fields.users'"
            [serviceId]="serviceIdChange()"
            [employment]="[EmploymentParentGroupEnum.DIRECT_CARE, EmploymentParentGroupEnum.SUPPORTIVE_CARE]"
            id="users"
        ></app-input-user-multiselect>

        <app-date-input
            [prefix]="prefix"
            [form]="form"
            id="dateFrom"
            [showTime]="true"
            [disabled]="existingWork?.isBilled || false"
        ></app-date-input>
        <app-date-input
            [prefix]="prefix"
            [form]="form"
            id="dateTo"
            [showTime]="true"
            [disabled]="existingWork?.isBilled || false"
        ></app-date-input>

        <app-number-input
            #applicationsComponent
            id="applications"
            [prefix]="prefix"
            [disabled]="existingWork?.isBilled || false"
            (selectedValueChange)="setDuration($event)"
        ></app-number-input>

        <app-select-person
            #selectPersonComponent
            [multiple]="true"
            [form]="form"
            [serviceId]="form.getRawValue().serviceId || existingWork?.serviceId || 0"
            [label]="prefix + 'fields.personIds'"
            id="personIds"
        ></app-select-person>

        <app-work-participants-select
            [form]="form"
            id="participantIds"
            [label]="prefix + 'fields.participantIds'"
            [serviceId]="form.getRawValue().serviceId || existingWork?.serviceId || 0"
            [folders]="participantFolders()"
            [atDate]="dateFromChange()"
            [autoSelectAll]="!existingWork"
        ></app-work-participants-select>

        <app-select-input
            [prefix]="prefix"
            [form]="form"
            [staticOptions]="allowedForms()"
            id="form"
        ></app-select-input>

        <app-select-input
            [prefix]="prefix"
            id="presence"
            [form]="form"
            [staticOptions]="store.presenceOptions()"
        ></app-select-input>

        <app-work-group-activity-user-table
            #usersTable
            class="fr-full"
            [users]="selectedUsers()"
            [maximumDuration]="form.getRawValue().duration"
            [minimumDurations]="userMinimumDurations()"
            [defaultValues]="existingWork?.offers"
            [disabled]="existingWork?.isBilled || false"
        ></app-work-group-activity-user-table>

        <app-card class="fr-full" [title]="'service.offer.labelMulti'">
            <ng-template #content>
                <div class="flex-column gap pt-2">
                    <app-work-credit-group
                        #creditGroup
                        [serviceId]="serviceIdChange()"
                        [folderIds]="folderIds()"
                        [date]="dateFromChange()"
                        [replacedWorkIds]="replacedCreditWorkIds()"
                    />
                    <app-social-service-select-offer
                        [form]="form"
                        [serviceId]="form.getRawValue().serviceId"
                        [date]="dateFromChange()"
                        id="offers"
                        (selectedOffers)="setOffers($event)"
                        [defaultUsers]="form.getRawValue().users"
                        [singleSelectedMode]="true"
                        [enableNoRecordOffers]="false"
                    ></app-social-service-select-offer>

                    <app-social-service-select-offer-table
                        #offerTableComponent
                        [serviceId]="form.getRawValue().serviceId"
                        [offers]="form.getRawValue().subOffers"
                        [dateFrom]="dateFromChange()"
                        [showFolders]="true"
                        [creditOffers]="creditGroup.creditOffers()"
                        [defaultPresence]="form.getRawValue().presence"
                        [offerSelectOptions]="selectOfferComponent()?.offerOptions()"
                        [maxApplication]="form.getRawValue().duration"
                        [setMaxApplicationOnInit]="true"
                        [showDetail]="true"
                        [disabled]="existingWork?.isBilled || false"
                        tableKey="socialServiceSelectOfferGroupActivity"
                        (updatedValues)="updateOfferValues()"
                    ></app-social-service-select-offer-table>
                </div>
            </ng-template>
        </app-card>

        <app-card class="appCard_full"
            [class.fr-3]="!useSplitter()"
            [class.fr-full]="useSplitter()"
        >
            <ng-template #header>
                <div class="flex justify-content-between align-items-center gap-small small-buttons">
                    <div class="textSubheader font-bold flex-1">
                        {{ prefix + 'fields.note' | translate }}
                    </div>
                    <app-button
                        class="justify-self-end"
                        label="workData.individualWork.message.copyNoteAndTags"
                        icon="pi-file-import"
                        [disabled]="existingWork?.isBilled || false"
                        (clickEvent)="copyNoteAndTags()"
                    ></app-button>
                </div>
            </ng-template>

            <ng-template #content>
                <div class="flex-column gap pt-2">
                    <app-tags-input
                        #tagsInput
                        class="justify-self-end"
                        [showClear]="true"
                        [prefix]="prefix"
                        [form]="form"
                        id="tags"
                        [suggestions]="store.data.searchWorkTags()"
                        (queryEvent)="queryTags($event)"
                    ></app-tags-input>
                    <app-service-pattern-wysiwyg
                        [form]="form"
                        [serviceId]="form.getRawValue().serviceId"
                        [height]="450"
                        [showLabel]="false"
                        [placeholder]="prefix + 'fields.note'"
                        [showHelpText]="true"
                        [helpText]="prefix + 'fields.noteHelp'"
                        id="note"
                        editorKey="WorkIndividualWork"
                        [usage]="ServicePatternStructureUsageEnum.GROUP_ACTIVITY_RECORD"
                        (addedPattern)="formAddText(form, 'note', $event.content)"
                    ></app-service-pattern-wysiwyg>
                </div>
            </ng-template>
        </app-card>

        <div
            class="flex flex-column gap appCard_full"
            [class.fr-2]="!useSplitter()"
            [class.fr-full]="useSplitter()"
        >
            <app-file-upload-box #files [multiple]="true"></app-file-upload-box>
            <app-work-individual-work-operational-report-widget
                #operationalReportWidget
                [serviceId]="form.getRawValue().serviceId"
                [structureDisabled]="existingWork?.isBilled || false"
            ></app-work-individual-work-operational-report-widget>
        </div>

        <app-action-buttons
            class="fr-full"
            (primaryClickEvent)="save()"
            [primaryButtonLoading]="store.loadingAny()"
            [primaryButtonVisibility]="canSave()"
            [primaryButtonDisability]="creditGroupComponent()?.insufficientBalance() || false"
            (secondaryClickEvent)="close()"
        ></app-action-buttons>
    </div>
</ng-template>

<ng-template #rightPanel>
    <div class="displayGrid p-3 w-full">
        <app-button
            class="fr-first justify-self-end"
            icon="pi-times"
            [outlined]="true"
            (clickEvent)="useSplitter.set(false)"
        ></app-button>
        <div class="flex align-items-start fr-first">
            @if (existingWork) {
                <app-card-content
                    [work]="$any(existingWork)"
                    [inSplitter]="true"
                    (copyTextToForm)="form.patchValue({ note: $event })"
                ></app-card-content>
            }
        </div>
    </div>
</ng-template>

<!-- Just adding second panel will not render it -> must force refresh of whole component -->
@if (useSplitter()) {
    <app-splitter
        [fullHeight]="true"
        [panelSizes]="[60, 40]"
    >
        <ng-template #panel>
            <ng-container *ngTemplateOutlet="leftPanel"></ng-container>
        </ng-template>
        <ng-template #panel>
            <ng-container *ngTemplateOutlet="rightPanel"></ng-container>
        </ng-template>
    </app-splitter>
} @else {
    <app-splitter
        [fullHeight]="true"
    >
        <ng-template #panel>
            <ng-container *ngTemplateOutlet="leftPanel"></ng-container>
        </ng-template>
    </app-splitter>
}
